import './AddCommLoopModal.scss';
import React, { useEffect, useState } from 'react';

import SettingsModal from 'src/component/UI/SettingsModal/SettingsModal';

import { useSelector, useDispatch } from 'react-redux';
import { fromJS } from 'immutable';

import { fetchIntegrations } from 'src/module/integration/action';
import { getIntegrations } from 'src/module/integration/selector';
import { setSettingsModalClose } from 'src/module/device/action';
import { getSettingsModal } from 'src/module/device/selector';
import { SettingsModalTypes } from 'src/component/UI/SettingsModal/SettingsModalTypes';
import { addCommLoop } from 'src/module/device/action';
import { useTranslation } from 'src/i18n';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { buildTcpFields, buildSerialFields } from 'src/component/UI/commLoopFieldDefs';

export default function AddCommLoopModal () {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [connectionType, setConnectionType] = useState<'tcp' | 'serial'>('tcp');

  const integrations = useSelector(getIntegrations);
  const settingsModal = useSelector(getSettingsModal(null));
  useEffect(() => {
    dispatch(fetchIntegrations());
    dispatch(setSettingsModalClose(null));
  }, []);

  let frogName = null, frogId = null;
  const frogClients = [];
  integrations?.forEach(integration => {
    if (integration.get('type') === 'frog') {
      frogId = integration?.get('id');
      frogName = integration?.getIn(['settings', 'name']) || frogId.substring(0, 5);
      frogClients.push({ label: frogName, value: frogId });
    }
  });

  const tcpFields = buildTcpFields(frogClients, t);
  const serialFields = buildSerialFields(frogClients, t);

  const handleClose = () => {
    dispatch(setSettingsModalClose(null));
  };

  const commLoopModalSubmit = (rec: any) => {
    if (connectionType === 'tcp') {
      let port = rec.get('port', null);
      if (port) {
        port = parseInt(port);
      }
      rec = rec.set('port', port);
    }
    dispatch(addCommLoop(rec));
  };

  const modalTitle = (
    <div>
      <div className="add-comm-loop-modal-title">
        <span>{t('commLoops.addCommLoop')}</span>
      </div>
      <div className="add-comm-loop-toggle-wrapper">
        <ButtonGroup size="medium" className="add-comm-loop-connection-type-toggle">
          <Button
            variant={connectionType === 'tcp' ? 'contained' : 'outlined'}
            onClick={() => setConnectionType('tcp')}
          >
            TCP
          </Button>
          <Button
            variant={connectionType === 'serial' ? 'contained' : 'outlined'}
            onClick={() => setConnectionType('serial')}
          >
            {t('commLoops.serialComPort')}
          </Button>
        </ButtonGroup>
      </div>
    </div>

  ) as any;

  return (
    <SettingsModal
      open={settingsModal?.get('isOpen') && settingsModal?.get('id') === SettingsModalTypes.ADD_COMM_LOOP}
      handleClose={handleClose}
      handleSubmit={commLoopModalSubmit}
      title={modalTitle}
      loading={settingsModal?.get('loading')}
      fields={
        fromJS(connectionType === 'tcp' ? tcpFields : serialFields)
      }
    />
  );
}

AddCommLoopModal.propTypes = {
};

AddCommLoopModal.defaultProps = {
};
